<div class="status-container" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
  <mat-icon [svgIcon]="backgroundStatusIcon"></mat-icon>
  <mat-icon *ngIf="responsivenessViewMode.isPhone" svgIcon="chevron-right"></mat-icon>
</div>
